import { stopIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Stop = createIcon({
  displayName: 'Stop',
  paths: [
    'M256 170.667h512c47.128 0 85.333 38.205 85.333 85.333v512c0 47.128-38.205 85.333-85.333 85.333h-512c-47.128 0-85.333-38.205-85.333-85.333v-512c0-47.128 38.205-85.333 85.333-85.333z'
  ],
  canvasPaths: canvasIconPaths(stopIcon)
})
